import { PublicApi } from '@/features/api/services/publicApi.js'

function is200(response) {
  return response?.status === 200
}

export function useClubTheming(clubId) {
  async function logoGet() {
    try {
      return await PublicApi.tenantLogoDownloadImage(clubId)
    } catch (error) {
      console.error('Error while fetching logo', error)
      return null
    }
  }

  async function backgroundGet() {
    try {
      return await PublicApi.tenantLogoBackgroundImage(clubId)
    } catch (error) {
      console.error('Error while fetching background', error)
      return null
    }
  }

  async function detailsGet() {
    try {
      return await PublicApi.tenantDetails(clubId)
    } catch (error) {
      console.error('Error while fetching details', error)
      return null
    }
  }

  async function fetchClubTheme() {
    try {
      const [logoResult, backgroundResult, detailsResult] = await Promise.allSettled([
        logoGet(),
        backgroundGet(),
        detailsGet(),
      ])

      const logo =
        logoResult.status === 'fulfilled' && is200(logoResult.value)
          ? URL.createObjectURL(logoResult.value.data)
          : null

      const background =
        backgroundResult.status === 'fulfilled' && is200(backgroundResult.value)
          ? URL.createObjectURL(backgroundResult.value.data)
          : null

      const brandColors = (() => {
        if (detailsResult.status === 'fulfilled' && detailsResult.value?.brandColor) {
          try {
            return JSON.parse(detailsResult.value.brandColor)
          } catch {
            return {}
          }
        }
        return {}
      })()

      return {
        logo,
        background,
        brandColors,
      }
    } catch (e) {
      console.error('Error while fetching club theme', e)
      return {
        logo: null,
        background: null,
        brandColors: {},
      }
    }
  }

  return {
    fetchClubTheme,
  }
}
